import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

// Event type configuration with icons and colors
const EVENT_TYPE_CONFIG = {
  inicio: { icon: '🚀', label: 'Início', color: '#28a745' },
  final: { icon: '🏁', label: 'Final', color: '#dc3545' },
  paragem: { icon: '📍', label: 'Paragem', color: '#ffc107' },
  emergencia: { icon: '🚨', label: 'Emergência', color: '#ff4444' }
};

// Custom event icon
const eventIcon = new L.Icon({
  iconUrl: 'data:image/svg+xml;base64,' + btoa(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32">
      <circle cx="12" cy="12" r="11" fill="#28a745" stroke="#ffffff" stroke-width="2"/>
      <path d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z"
            fill="#ffffff" stroke="none"/>
    </svg>
  `),
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  shadowSize: [41, 41],
  shadowAnchor: [13, 41]
});

const EventMarker = ({ event, onEventClick }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('pt-PT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleMarkerClick = () => {
    if (onEventClick) {
      onEventClick(event);
    }
  };

  return (
    <Marker
      position={[event.location.latitude, event.location.longitude]}
      icon={eventIcon}
      eventHandlers={{
        click: handleMarkerClick
      }}
    >
      <Popup>
        <div className="event-popup">
          <div className="event-header">
            <h4 style={{ margin: '0 0 8px 0', color: '#28a745' }}>
              📋 Evento Registado
            </h4>
          </div>

          <div className="event-details">
            {event.tipo && (
              <div className="event-row">
                <strong>Tipo:</strong>
                <span style={{ marginLeft: '4px' }}>
                  {EVENT_TYPE_CONFIG[event.tipo]?.icon} {EVENT_TYPE_CONFIG[event.tipo]?.label || event.tipo}
                </span>
              </div>
            )}

            <div className="event-row">
              <strong>Entidade:</strong> {event.entity.name}
            </div>

            {event.ronda_name && (
              <div className="event-row">
                <strong>Ronda:</strong> {event.ronda_name}
              </div>
            )}

            {event.local && (
              <div className="event-row">
                <strong>Local:</strong> {event.local}
              </div>
            )}

            <div className="event-row">
              <strong>Pessoas assistidas:</strong>
              <span className="badge" style={{
                backgroundColor: '#28a745',
                color: 'white',
                padding: '2px 6px',
                borderRadius: '4px',
                marginLeft: '4px'
              }}>
                {event.pessoas_assistidas}
              </span>
            </div>

            {event.numero_refeicoes > 0 && (
              <div className="event-row">
                <strong>Refeições servidas:</strong>
                <span className="badge" style={{
                  backgroundColor: '#17a2b8',
                  color: 'white',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  marginLeft: '4px'
                }}>
                  {event.numero_refeicoes}
                </span>
              </div>
            )}

            <div className="event-row">
              <strong>Data:</strong> {formatDate(event.created_at)}
            </div>

            <div className="event-coordinates" style={{
              marginTop: '8px',
              fontSize: '0.8em',
              color: '#6c757d'
            }}>
              📍 {event.location.latitude.toFixed(6)}, {event.location.longitude.toFixed(6)}
            </div>
          </div>
        </div>
      </Popup>
    </Marker>
  );
};

export default EventMarker;